// extracted by mini-css-extract-plugin
module.exports = {"alert-orange":"_1ZRdC_FizhQZE2r8-01Tng","warning-icon":"ZRb7bAQNyvPLGKVG0pv5x"};